import { add, remove, qsa } from "@fluorescent/dom";
import { delayOffset } from "@/lib/animation";

const selectors = {
  animationHeading: ".animation--purchase-confirmation-heading",
  animationItems: ".animation--purchase-confirmation-item",
  animationFooterItems: ".animation--purchase-confirmation-footer-item",
};

const classes = {
  animationRevealed: "animation--purchase-confirmation-revealed",
  animationExiting: "animation--purchase-confirmation-exiting",
  animationHeadingExiting: "animation--purchase-confirmation-heading-exiting",
  animationSwapping: "animation--purchase-confirmation-swapping",
};

export default node => {
  // delayOffset counts all matching elements including hidden cart items, which
  // would push the visible product card to a high multiplier and break the order.
  // Filter to visible items only before assigning multipliers.
  function _visibleItems() {
    return qsa(selectors.animationItems, node).filter(
      item => !item.classList.contains("hidden")
    );
  }

  function animate() {
    _visibleItems().forEach((item, i) => {
      item.style.setProperty("--delay-offset-multiplier", i);
    });
    delayOffset(node, [selectors.animationFooterItems]);

    setTimeout(() => {
      add(node, classes.animationRevealed);
    }, 150);
  }

  function reset() {
    qsa(selectors.animationHeading, node).forEach(item =>
      add(item, classes.animationHeadingExiting)
    );
    remove(node, classes.animationRevealed);
  }

  function exitProduct(onComplete) {
    _visibleItems().forEach(item => add(item, classes.animationExiting));
    setTimeout(onComplete, 150);
  }

  function animateSwap() {
    const items = _visibleItems();
    items.forEach((item, i) => {
      item.style.setProperty("--delay-offset-multiplier", i);
      add(item, classes.animationSwapping);
      item.addEventListener(
        "animationend",
        () => remove(item, classes.animationSwapping),
        { once: true }
      );
    });
  }

  return {
    animate,
    exitProduct,
    animateSwap,
    reset,
  };
};
